import { gql } from '@apollo/client';

/* eslint-disable import/prefer-default-export */

export const REDSYS_FRAGMENT = gql`
  fragment RedsysFormFragment on RedsysForm {
    data
  }
`;